export default "__VITE_PUBLIC_ASSET__76a1a475__"